export const trialsApiPaths = {
  list: '/facilityservice/trial-programs',
} as const;

export const getTrialProgramsApiUrl = {
  list: () => trialsApiPaths.list,
};
